// extracted by mini-css-extract-plugin
export var container = "gdpr-module--container--GHBoh";
export var wrapper = "gdpr-module--wrapper--KRiie";
export var buttons = "gdpr-module--buttons--M9+4B";
export var show = "gdpr-module--show--8QhQ0";
export var showUp = "gdpr-module--showUp--Uz4lA";